document.addEventListener('DOMContentLoaded', function() {
    var toggleIcons = document.querySelectorAll('.toggle-icon');

    // Function to toggle dropdown and rotate icon
    function toggleDropdown(icon) {
        var dropdown = icon.parentNode.querySelector('.menu.dropdown-child, .menu.dropdown-grandchild');
        if (dropdown) {
            dropdown.classList.toggle('open');
            icon.classList.toggle('rotated', dropdown.classList.contains('open'));
        }
    }

    // Set up click listeners for toggle icons
    toggleIcons.forEach(function(icon) {
        icon.addEventListener('click', function(e) {
            e.preventDefault();
            toggleDropdown(icon);
        });
    });

    // Rotate icon for open dropdowns on page load
    toggleIcons.forEach(function(icon) {
        var dropdown = icon.parentNode.querySelector('.menu.dropdown-child, .menu.dropdown-grandchild');
        if (dropdown && dropdown.classList.contains('open')) {
            icon.classList.add('rotated');
        }
    });
});



